export const getNodeId = (id: string) => `cu-${id}`;

export const getStyleguideClass = (className: string) => `candu-${className}`;
